import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/_global.scss";
import "./App.scss";
import "./appleThemeOverride.scss"; // Import Apple theme override
import "./forceAppleTheme.css"; // Force Apple theme with !important rules
import "./appleDesignSystem.css"; // Import consistent Apple design system
import "./titleConsistency.css"; // Force consistent titles and subtitles
import "./forceConsistentTitles.css"; // Final override for consistent titles
import "./fixOverlappingTitles.css"; // Fix for overlapping titles and subtitles
import "./finalHeaderFix.css"; // Final fix for header spacing
import "./fixTechStackAndProjects.css"; // Fix for tech stack and GitHub projects
import "./fixEducationSection.css"; // Fix for education section
import "./fixEmptySubtitle.css"; // Fix for sections with empty subtitles
import "./reducedProjectCardText.css"; // Reduced text size for project cards
import "./compactProjectCards.css"; // More compact project cards
import "./appleProjectCards.css"; // Apple-like styling for project cards
import "./fixProjectsNavigation.css"; // Fix for Projects section navigation
import "./mobileResponsiveFix.css"; // Existing mobile responsive fixes
import "./fixMainLayout.css"; // Fix for main layout structure
import "./fixTechStackMobile.css"; // Fix for Tech Stack on mobile
import "./fixProjectsMobile.css"; // Fix for Projects section on mobile
import "./fixIOSSpecific.css"; // iOS-specific fixes
import "./fixGreetingMobile.css"; // Fix for Greeting section on mobile
import "./fixHeaderMobile.css"; // Fix for Header and Navigation on mobile
import "./fixFooterMobile.css"; // Fix for Footer on mobile
import "./fixBackToTopMobile.css"; // Fix for Back to Top button on mobile
import "./fixTimelineMobile.css"; // Fix for Timeline section on mobile
import "./fixGalleryMobile.css"; // Fix for Gallery section on mobile
import "./fixBlogsMobile.css"; // Fix for Blogs section on mobile
import "./fixContactMobile.css"; // Fix for Contact section on mobile
import "./fixAchievementsMobile.css"; // Fix for Achievements section on mobile
import "./fixExperienceMobile.css"; // Fix for Experience section on mobile
import "./fixEducationMobile.css"; // Fix for Education section on mobile
import "./fixTypographyMobile.css"; // Fix for Typography on mobile
import "./fixFinalLayout.css"; // Final layout fixes for mobile
import "./fixAchievementCardsMobile.css"; // Fix for Achievement Cards on mobile
import "./fixGalleryImagesMobile.css"; // Fix for Gallery Images on mobile
import "./fixCertificationButtonsMobile.css"; // Fix for Certification Buttons on mobile
import "./fixGalleryAndCertificationsMobile.css"; // Fix for Gallery and Certifications on mobile
import "./comprehensiveMobileFix.css"; // Comprehensive mobile responsive fixes
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Import FontAwesome configuration
import "./fontawesome";

// Ensure process exists
if (typeof process === 'undefined') {
  console.warn('Process polyfill not loaded, creating basic version');
  window.process = {
    env: {
      NODE_ENV: 'production'
    }
  };
}

// For React 18
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Completely disable service worker
serviceWorker.unregister();

// Force unregister any existing service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      console.log('Unregistering service worker:', registration);
      registration.unregister();
    }
  });
}

// Add cache busting for all environments
// Using true instead of checking process.env to ensure it always runs
if (true) {
  // Add a version query parameter to all asset URLs to prevent caching
  const originalCreateElement = document.createElement;
  document.createElement = function() {
    const element = originalCreateElement.apply(this, arguments);

    const originalSetAttribute = element.setAttribute;
    element.setAttribute = function(name, value) {
      if (name === 'src' || name === 'href') {
        if (value && typeof value === 'string') {
          // Always add cache busting parameter, even if URL already has parameters
          const separator = value.indexOf('?') === -1 ? '?' : '&';
          value = value + separator + 'v=' + Date.now();
        }
      }
      return originalSetAttribute.call(this, name, value);
    };

    return element;
  };

  // Disable browser cache
  window.addEventListener('load', function() {
    // Clear application cache
    if (window.applicationCache) {
      window.applicationCache.addEventListener('updateready', function() {
        if (window.applicationCache.status === window.applicationCache.UPDATEREADY) {
          window.applicationCache.swapCache();
        }
      });
    }

    // Set cache control headers via meta tags
    const meta1 = document.createElement('meta');
    meta1.httpEquiv = 'Cache-Control';
    meta1.content = 'no-cache, no-store, must-revalidate';
    document.head.appendChild(meta1);

    const meta2 = document.createElement('meta');
    meta2.httpEquiv = 'Pragma';
    meta2.content = 'no-cache';
    document.head.appendChild(meta2);

    const meta3 = document.createElement('meta');
    meta3.httpEquiv = 'Expires';
    meta3.content = '0';
    document.head.appendChild(meta3);
  });

  // Removed hard refresh button
}
